module.exports = __webpack_public_path__ + "static/img/aa.326fb31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/aa.png
// module id = j9Y8
// module chunks = 0